import "../node_modules/swiper/swiper-bundle";

const home_partners = document.querySelector("#home_partners");
const home_products = document.querySelector("#home_products");
const home_blog = document.querySelector("#home_blog");
const investors = document.querySelector("#investors");
const api_mobile_titles = document.querySelector("#api_mobile_titles");

if (home_partners) {
  let partners_swiper = new Swiper(home_partners, {
    slidesPerView: 2.7,
    spaceBetween: 8,
    loop: true,
    loopFillGroupWithBlank: true,
    navigation: {
      nextEl: ".swiper-button-next.partner",
      prevEl: ".swiper-button-prev.partner",
    },
    autoplay: {
      delay: 1500,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 25,
      },
    },
  });
}

if (home_products) {
  let product_swiper = new Swiper(home_products, {
    slidesPerView: 1,
    spaceBetween: 26,
    autoplay: {
      delay: 1500,
    },
    navigation: {
      nextEl: ".swiper-button-next.product",
      prevEl: ".swiper-button-prev.product",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });
}

if (home_blog && window.screen.width > 575.98) {
  let blog_swiper = new Swiper(home_blog, {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    loopFillGroupWithBlank: true,
    navigation: {
      nextEl: ".swiper-button-next.blog",
      prevEl: ".swiper-button-prev.blog",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });
}

if (home_blog && window.screen.width < 575.98) {
  let slides_wrapper = home_blog.querySelector(".swiper-wrapper");
  let slides_wrapper_children = slides_wrapper.children;
  let new_slides_wrapper = [...slides_wrapper_children];
  new_slides_wrapper = new_slides_wrapper.slice(0, 3);
  slides_wrapper.innerHTML = "";
  new_slides_wrapper.forEach(function (slide) {
    slides_wrapper.appendChild(slide);
  });
}

if (investors) {
  let investors_swiper = new Swiper(investors, {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: ".swiper-button-next.investor",
      prevEl: ".swiper-button-prev.investor",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });
}
